import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ignoreThousandSeparator',
  standalone: true,
})
export class IgnoreThousandSeparatorPipe implements PipeTransform {
  public transform = (value: number) => (value ? value.toLocaleString(undefined, { useGrouping: false }) : '');
}
